import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { reduxForm } from 'antd-form-redux';
import { Icon, Tabs, Row, Col, Layout, List, Avatar } from 'antd';
import FormLogin from './FormLogin';
import FormRegistrar from './FormRegistrar';
import FormResetPassword from './FormResetPassword';
import logo from '../../images/logoEricson.png';
import { Redirect } from 'react-router-dom';

const { Sider, Content } = Layout;
const TabPane = Tabs.TabPane;

export class Login extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    auth: false,
    open: true,
  };
  validaRedirect = () => {
    const { Codigo = null } = this.props.acessoSistema.usuario || {};
    if (Codigo != null) {
      return <Redirect to="/" />;
    }
  };

  render() {
    // const { getFieldDecorator } = this.props.form;
    // if (this.props.acessoSistema.accessTokens.id) {
    //   this.props.history.push(`/`);
    // }

    const data = [
      {
        title: 'Telefonia',
        icone: 'mobile',
        descricao: 'Seus chamados e agendamentos para suporte de telefonia unificado.',
      },
      {
        title: 'Suporte a Sistemas',
        icone: 'code',
        descricao:
          'Suporte unificado para os sistemas Ericsson, onde você pode acompanhar a solução do problema.',
      },
      {
        title: 'Acessos',
        icone: 'lock',
        descricao: 'Abra seu chamado para solicitar acesso a sistemas e ferramentas da Ericsson.',
      },
      {
        title: 'Avaliação',
        icone: 'smile',
        descricao:
          'De o feedback do seu atendimento, agora você pode avaliar o atendimento do seu chamado. ',
      },
    ];

    return (
      <Layout style={{ minHeight: '100vh' }} className="acesso-sistema-login">
        <Sider width="400" breakpoint="md" collapsedWidth="0">
          <Row type="flex" justify="center" align="middle" style={{ minHeight: '100vh' }}>
            <Col xs={24} style={{ textAlign: 'center' }}>
              <img src={logo} style={{ width: '150px' }} alt="Logo" />
            </Col>
            <Col xs={24}>
              <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={item => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar shape="square" size="large" icon={item.icone} />}
                      title={item.title}
                      description={item.descricao}
                    />
                  </List.Item>
                )}
              />
              ,
            </Col>
          </Row>
        </Sider>
        <Layout style={{ minHeight: '100vh' }}>
          <Content style={{ minHeight: '100vh' }} className="acesso-sistema-login">
            <Row type="flex" justify="center" align="middle" style={{ minHeight: '100vh' }}>
              <Col xs={20} md={12}>
                <div>
                  <div>
                    <Tabs tabBarGutter={8} defaultActiveKey="1">
                      <TabPane
                        tab={
                          <span>
                            <Icon type="login" />
                            Acessar
                          </span>
                        }
                        key="1"
                      >
                        <FormLogin history={this.props.history} />
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <Icon type="form" />
                            Quero me cadastrar
                          </span>
                        }
                        key="2"
                      >
                        <FormRegistrar history={this.props.history} />
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <Icon type="" />
                            Esqueci minha senha
                          </span>
                        }
                        key="3"
                      >
                        <FormResetPassword history={this.props.history} />
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
              </Col>
            </Row>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}
Login = reduxForm({
  form: 'Login',
  // enableReinitialize: false,
  onSubmit: function(values, dispatch, props) {
    //do with values, dispatch , props
  },
})(Login);

Login = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);

export default Login;



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/Login.js